import { AppStates, START_LOGIN, START_QUIZ } from '../actions/appstate';
import { SHOW_FINAL_RESULTS } from '../actions/quiz';

const appState = (state = AppStates.INITIAL, action) => {
  switch (action.type) {
    case START_LOGIN:
      return AppStates.LOGIN;        
    case START_QUIZ:
      return AppStates.QUIZ;
    case SHOW_FINAL_RESULTS:
      return AppStates.RESULTS;
    default:
      return state
  }
}
  
export default appState;



// WEBPACK FOOTER //
// ./src/components/store/reducers/appstate.js